import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"


import { useRouter } from 'vue-router';
import { computed, ref, watch } from 'vue';
import { _CONFIG, _GRAPH } from '@shell/config/query-params';
import ButtonGroup from '@shell/components/ButtonGroup';
import { useCurrentView } from '@shell/components/Resource/Detail/ViewOptions/composable';

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const router = useRouter();

const currentView = useCurrentView();
const view = ref(currentView.value);
const viewOptions = computed(() => {
  return [
    {
      labelKey: 'resourceDetail.masthead.config',
      value:    _CONFIG,
    },
    {
      labelKey: 'resourceDetail.masthead.graph',
      value:    _GRAPH,
    }
  ];
});

watch(
  () => view.value,
  () => {
    router.push({ query: { view: view.value } });
  }
);

return (_ctx: any,_cache: any) => {
  return (viewOptions.value)
    ? (_openBlock(), _createBlock(_unref(ButtonGroup), {
        key: 0,
        value: view.value,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((view).value = $event)),
        options: viewOptions.value
      }, null, 8, ["value", "options"]))
    : _createCommentVNode("", true)
}
}

})